"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var flowReducer = function flowReducer(accumulator, currentValue) {
  return currentValue(accumulator);
};

var _default = function _default() {
  for (var _len = arguments.length, fn = new Array(_len), _key = 0; _key < _len; _key++) {
    fn[_key] = arguments[_key];
  }

  return function (param) {
    return fn.reduce(flowReducer, param);
  };
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/yourchoice/lib/flow.js
// module id = 77
// module chunks = 0